// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import {
  GoogleMap,
  withScriptjs,
  withGoogleMap,
  Marker,
  InfoWindow,
} from 'react-google-maps';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import EvriIcon from '../../../../images/store-evri.png';
import { GOOGLE_MAPS_API_KEY } from '../../../../config/apiKeys';
import Shop from '../Shop/Shop';
import styles from './styles';

class myMapInner extends React.Component {
  state = {
    openInfoWindowMarkerId: null,
  };

  handleToggleOpen = (markerId) => {
    this.setState({
      openInfoWindowMarkerId: markerId
    });
  }

  handleToggleClose = () => {
    this.setState({
      openInfoWindowMarkerId: null,
    });
  }

  renderMarker = (shop) => {
    return (
      <Marker
        icon={EvriIcon}
        key={shop.ExternalId}
        position={{ lat: parseFloat(shop.Lat), lng: parseFloat(shop.Lng) }}
        onClick={() => this.handleToggleOpen(shop.ExternalId)}
      >
        {this.state.openInfoWindowMarkerId === shop.ExternalId && (
          <InfoWindow
            onCloseClick={() => this.handleToggleClose()}
          >
            <Shop shop={shop} />
          </InfoWindow>)}
      </Marker>
    );
  }

  render() {
    const { shops } = this.props;
    return (
      <GoogleMap
        defaultZoom={14}
        defaultCenter={{ lat: 51.509865, lng: -0.118092 }}
        center={shops.length > 0
          ? { lat: parseFloat(shops[0].Lat), lng: parseFloat(shops[0].Lng) }
          : { lat: 51.509865, lng: -0.118092 }}
      >
        {shops.map(el => this.renderMarker(el))}
      </GoogleMap>
    );
  }
}

myMapInner.propTypes = {
  shops: PropTypes.array,
};
myMapInner.defaultProps = {
  shops: [],
};

const Wrapper = withScriptjs(withGoogleMap(myMapInner));

class MyMap extends React.Component {
  state = {};

  render() {
    const { shops } = this.props;
    return (
      <Wrapper
        shops={shops}
        googleMapURL={'https://maps.googleapis.com/maps/api/js?v=3.exp&libraries'
          + `=geometry,drawing,places&key=${GOOGLE_MAPS_API_KEY}`}
        loadingElement={<div style={{ height: '100%' }} />}
        containerElement={<div style={{ height: 400, width: '100%' }} />}
        mapElement={<div style={{ height: '100%' }} />}
      />
    );
  }
}

MyMap.propTypes = {
  shops: PropTypes.array,
};
MyMap.defaultProps = {
  shops: [],
};

export default withStyles(styles)(MyMap);
